export default [
  {
    path: "/admin/dealers-account-maintenance/sales-consultants",
    name: "dealers-account-maintenance.sales-consultants.index",
    component: () => import("../Index.vue"),
    meta: {
      title: "Sales Consultants",
      description: "Sales Consultants",
      sort: 0,
      authenticatable: true,
      permission: false,
      icon: "colors",
      roles: ["admin", "dealer"]
    },
  },
  {
    path: "/admin/dealers-account-maintenance/sales-consultants/create",
    name: "dealers-account-maintenance.sales-consultants.create",
    component: () => import("../Create.vue"),
    meta: {
      title: "Add new Dealer",
      description: "Create new Dealer",
      sort: 0,
      authenticatable: true,
      permission: false,
      icon: "colors",
      roles: ["admin", "dealer"]
    },
  },
  {
    path: "/admin/dealers-account-maintenance/sales-consultants/upload",
    name: "dealers-account-maintenance.sales-consultants.upload",
    component: () => import("../Upload.vue"),
    meta: {
      title: "Upload Sales Consultants",
      description: "Upload Sales Consultants via Excel",
      sort: 0,
      authenticatable: true,
      permission: false,
      icon: "colors",
      roles: ["admin", "dealer"]
    },
  },
  {
    path: "/admin/dealers-account-maintenance/dealers/:dealer_id/sales-consultants/:id",
    name: "dealers-account-maintenance.sales-consultants.edit",
    component: () => import("../Edit.vue"),
    meta: {
      title: "Edit Sales Consultant",
      sort: 0,
      authenticatable: false,
      permission: false,
      roles: ["admin"]
    },
  },
  {
    path: "/admin/dealers-account-maintenance/sales-consultants/:id",
    name: "dealers-account-maintenance.dealers.sales-consultants.edit",
    component: () => import("../Edit.vue"),
    meta: {
      title: "Edit Sales Consultant",
      sort: 0,
      authenticatable: false,
      permission: false,
      roles: ["admin", "dealer"]
    },
  },
];
